__turbopack_context__.v({
  "equalHeight": "_JEpZW_equalHeight",
  "playPauseButton": "_JEpZW_playPauseButton",
  "playPauseButtonWrapper": "_JEpZW_playPauseButtonWrapper",
  "showArrows": "_JEpZW_showArrows",
  "slideElementWrapper": "_JEpZW_slideElementWrapper",
  "slider": "_JEpZW_slider",
});
